import { Constants } from "constants/constants";
import { roughSizeOfObject } from "hooks/utils/api_helpers";
import { Cookie } from "hooks/utils/cookies";

export function getClientCookie(cookie_name) {
  return Cookie.get(cookie_name);
}
export async function getServerCookie(cookie_name) {
  if (!cookie_name) {
    return null;
  }
  //get cookies from the server
  const { cookies } = await import("next/headers");
  const cookieStore = await cookies();
  const cookie = cookieStore.get(cookie_name);
  return cookie?.value;
}

async function getAuthenticatedConfig() {
  let login_cookie;
  if (typeof window == "undefined") {
    login_cookie = await getServerCookie(Constants.login_cookie);
  } else {
    login_cookie = getClientCookie(Constants.login_cookie);
    login_cookie = encodeURIComponent(login_cookie);
  }

  const config = {
    headers: { Authorization: `Bearer ${login_cookie}` },
  };

  return config;
}

async function nan_backend(method, url, body, extra_options = {}) {
  const config = await getAuthenticatedConfig();

  return await nan_fetch(method, Constants.erp_url + "api/" + url, body, {
    ...config,
    ...extra_options,
  });
}

async function nan_wp(method, url, body, extra_options = {}) {

  return await nan_fetch(
    method,
    Constants.api_url + "wp-json/notanumber/v1/gsfurn/" + url,
    body,
    {
      ...extra_options,
    }
  );
}
async function nan_main_wp(method, url, body, extra_options = {}) {

  return await nan_fetch(
    method,
    Constants.main_api_url + "wp-json/notanumber/v1/gsfurn/" + url,
    body,
    {
      ...extra_options,
    }
  );
}

async function nan_fetch(method = "GET", url, body, extra_options = {}) {
  let time = Date.now();
  const is_client = typeof window !== "undefined";
  const skip_cache = Constants.skip_cache || method != "GET" || is_client;

  const cache_method = skip_cache ? "no-store" : "force-cache";

  let result;
  let options = { method, cache: cache_method };
  if (extra_options) {
    options = {
      ...options,
      ...extra_options,
    };
  }
  if (body && body instanceof FormData) {
    options.body = body;
    options.headers = {
      ...(options.headers || {}),
    };
  } else if (body) {
    options.body = JSON.stringify(body);
    options.headers = {
      ...(options.headers || {}),
      "Content-Type": "application/json",
    };
  }
  try {
    options.headers = {
      ...options.headers,
      "x-nan-next-tags": (extra_options?.next?.tags || []).join(", "),
    };
    const response = await fetch(url, options);
    result = await response.json();
    if (!response.ok) {
      return {
        error: true,
        status: response.status,
        statusText: response?.statusText,
        result,
      };
    }
  } catch (error) {
    result = { error: error.toString() };
  } finally {
    logResult(method, url, time, body, result, options);
  }
  return result;
}

function logResult(method, url, start_time, body, result, options) {
  const size = roughSizeOfObject(result);
  const duration = Date.now() - start_time;
  if (typeof window !== "undefined") {
    console.groupCollapsed(` ${method} ${url} in ${duration}ms`);
    console.debug(`method: `, method);
    console.debug(`url: `, url);
    console.debug(`call took ${duration} ms `);
    console.debug(`size of response`, size);
    console.debug(`body: `, body);
    console.debug(`options: `, options);

    console.debug(`response gave`, result);
    console.groupEnd();
  } else {
    // const next_tags = options?.headers?.["x-nan-next-tags"] || "";
    // console.debug(
    //   `${method} to url ${url} took ${duration} ms with size ${size} and tags ${next_tags}`
    // );
  }
}

function getFunctions(method) {
  return {
    laravel: async (...props) => nan_backend(method, ...props),
    wp: async (...props) => nan_wp(method, ...props),
    main_wp: async (...props) => nan_main_wp(method, ...props),
    basic: async (...props) => nan_fetch(method, ...props),
  };
}

export const NanFetch = {
  get: {
    ...getFunctions("GET"),
  },
  post: {
    ...getFunctions("POST"),
  },
  put: {
    ...getFunctions("PUT"),
  },
  delete: {
    ...getFunctions("DELETE"),
  },
};
export async function nan_get_wp(path) {
  const result = await NanFetch.get.basic(
    Constants.api_url + "wp-json/notanumber/v1/gsfurn/" + path
  );

  return result;
}
